import React, { Component } from 'react';
import {
	ResponsiveContainer, Tooltip, CartesianGrid, XAxis, YAxis,
	BarChart, Bar, LabelList
} from 'recharts';
import BlockUi from 'react-block-ui';
import { COLORS } from '../../home/utils';
import ValueModeSwitch from '../../home/ValueModeSwitch';
import { withTranslation } from 'react-i18next';

const ValueMode = {
	TOP: 'top',
	ALL: 'all'
};

const TopCount = 10;

class LessonPaymentsByMasterFranchisee extends Component {
	constructor(props) {
		super(props);
		this.handleModeChange = this.handleModeChange.bind(this);
		this.state = {
			mode: ValueMode.TOP
		};
	}

	handleModeChange(mode) {
		this.setState({ mode });
	}

	render() {
		const { loading, data, height = 300, t } = this.props;
		const { mode } = this.state;

		const showTop = data && data.length > TopCount;
		const visibleData = data && (showTop && mode === ValueMode.TOP ? data.slice(0, TopCount) : data);

		let containerHeight = visibleData && visibleData.length >= TopCount ? visibleData.length * 40 : height;

		return <BlockUi blocking={loading}>
			{showTop && <ValueModeSwitch selectedMode={mode} onChange={this.handleModeChange} modes={[{ value: ValueMode.TOP, label: t('SalesDashboard_SalesByCenter_Top') }, { value: ValueMode.ALL, label: t('SalesDashboard_SalesByCenter_All') }]} />}
			<ResponsiveContainer height={containerHeight}>
				<BarChart data={visibleData} layout='vertical'>
					<YAxis dataKey='name' type='category' width={200} />
					<XAxis xAxisId='top' orientation='top' stroke={COLORS[0]} axisLine={false} tickLine={false} type='number' />
					<XAxis xAxisId='bottom' orientation='bottom' stroke={COLORS[1]} axisLine={false} tickLine={false} type='number' />
					<CartesianGrid horizontal={false} />
					<Tooltip label='name' />
					{/*<Bar xAxisId='top' name={t('SalesDashboard_Revenue')} dataKey='amount' fill={COLORS[0]} maxBarSize={20} />*/}
					<Bar xAxisId='bottom' name={t('SalesDashboard_NumberOfSales')} dataKey='count' fill={COLORS[1]} maxBarSize={20} />
				</BarChart>
			</ResponsiveContainer>
		</BlockUi>;
	}
}

export default withTranslation()(LessonPaymentsByMasterFranchisee);